import React, { ReactElement, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Header } from '../..';
import DevUnlockBanner from '../../DevUnlockBanner';
import { sendCodeForSISECI } from '../../../services/auth';
import { useStateValue } from '../../../providers/StateProvider';
import { isDevUnlockRoutesEnabled } from '../../../utils/devUnlock';

interface Props {
  children: JSX.Element;
  window?: () => Window;
}

export default function Dash(props: Props): ReactElement {
  const { children } = props;
  const history = useHistory();
  const location = useLocation();
  const [, dispatch] = useStateValue();
  const devUnlockActive = isDevUnlockRoutesEnabled();
  useEffect(() => {
    const url = (window as any).location.search;
    const { pathname } = location;
    const query = new URLSearchParams(url);
    const code: any = query.get('code');
    if (code) {
      localStorage.setItem('pathname_redirect_gov', pathname);
      sendCodeForSISECI(code, history, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {devUnlockActive && <DevUnlockBanner />}
      <Header />
      {children}
    </>
  );
}
